import React from 'react'
// import CsvReader2 from './CsvReader2'
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import EditableTable from './EditableTable';

const Data = () => {
    // const onTabChange = () => {

    // }
    return (
        <div style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box', overflow: 'hidden' }}>
            <EditableTable />
        </div>
    )
}

export default Data
